<template>
    <component :is='layout'>
      <router-view/>
    </component>
</template>

<script>
  import LoginLayout from '@/layouts/login'
  import MainLayout from '@/layouts/main'
  export default {
    computed: {
      layout() {
        window.console.log(this.$route.meta.layout)
        return (this.$route.meta.layout || 'login') +'-layout'
      }
    },
    components: {
      LoginLayout, MainLayout
    }
  };
</script>
<style lang="sass">

</style>
